module.exports = __webpack_public_path__ + "static/media/Your Salesperson.7c1aad4b.png";